const f = {
  color: {
    grey: {
      text: "#405261ff",
      border: "#c8d3deff",
      bg: "#f9fafaff"
    },
    white: {
      bg: "#ffffffff"
    }
  }
};
export {
  f as badgeCount
};
